var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.74,
    cy: 25.8017,
    rx: 25.74,
    ry: 25.8017,
    fill: "#3282C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.652 23.7376C23.7892 23.7376 24.7112 22.8135 24.7112 21.6735C24.7112 20.5335 23.7892 19.6094 22.652 19.6094C21.5147 19.6094 20.5928 20.5335 20.5928 21.6735C20.5928 22.8135 21.5147 23.7376 22.652 23.7376Z",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7709 15.4805H22.6525C17.5045 15.4805 15.4453 17.5446 15.4453 22.7049V28.8974C15.4453 34.0577 17.5045 36.1218 22.6525 36.1218H28.8301C33.9781 36.1218 36.0373 34.0577 36.0373 28.8974V23.737",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 18.5767H35.2644",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4336 21.4151V15.7388",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1357 32.9738L21.2117 29.5576C22.0251 29.0107 23.1988 29.0726 23.9298 29.7021L24.2696 30.0014C25.0727 30.6929 26.37 30.6929 27.1731 30.0014L31.4562 26.317C32.2593 25.6255 33.5566 25.6255 34.3597 26.317L36.0379 27.7618",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.dae27f3ca461df6d490b7557b2185330.svg";
export { ForwardRef as ReactComponent };